module.exports = __webpack_public_path__ + "img/icon-flag-ge.e8a39441.svg";